import { useQuery } from "@octopusdeploy/octopus-react-client";
import { useState } from "react";
import { useDialogTrigger } from "~/components/Dialog/DialogTrigger";
import type { TemplateWizardSteps } from "./ProjectTemplateWizardDialog";

export function useProjectTemplateWizard() {
    const { openDialog, isOpen, closeAllDialogs } = useDialogTrigger();
    const [wizardSteps, setWizardSteps] = useState<TemplateWizardSteps[]>([]);
    const [commitHandler, setCommitHandler] = useState<((msg: string) => Promise<void>) | undefined>();
    const [afterSaveCallback, setAfterSaveCallback] = useState<(() => void) | undefined>();

    const openWizard = (steps: TemplateWizardSteps[], onAfterSave?: () => void, handler?: (msg: string) => Promise<void>) => {
        setWizardSteps(steps);
        setCommitHandler(handler ? () => handler : undefined);
        setAfterSaveCallback(onAfterSave ? () => onAfterSave : undefined);
        openDialog();
    };

    return {
        isOpen,
        openWizard,
        closeWizard: closeAllDialogs,
        dialogProps: { stepsToShow: wizardSteps, commitHandler, onAfterSave: afterSaveCallback, onClose: closeAllDialogs },
    };
}

export function useIsProjectTemplateShared(slug: string): { isShared: boolean; refetchIsShared: () => void } {
    const { result, refetch } = useQuery((repo) => repo.ProjectTemplates.getSharedSpaces(slug), [slug], "Check if project template is shared");
    const isShared = result ? result.SharedToAllSpaces || result.IndividuallySharedSpaceIds.length > 0 : false;

    return { isShared, refetchIsShared: refetch };
}
